/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useState } from 'react';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

import './animation023.less';

interface IAnimation023SubItem {
  img: string;
  title: string;
  content: string;
}
interface IAnimation023Item {
  img1: string;
  img2: string;
  text: string;
  subtitle?: string;
  subItems?: IAnimation023SubItem[];
}

interface IAnimation023Props {
  items: IAnimation023Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation023: React.FunctionComponent<IAnimation023Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1500);
    } else {
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className={`animation023 component ${className || ''}`}>
      <img
        className="click-point1"
        onClick={() => clickToPlay()}
        style={{
          display: play <= 1 ? 'block' : 'none',
        }}
        src={ImgPoint}
        alt=""
      />
      {items.map((itm: IAnimation023Item, idx: number) => (
        <div key={idx} className="animation023-contaner">
          <div
            onClick={() => clickToPlay()}
            className={`animation023-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <img
              src={
                windowWidth > 1500 || windowWidth <= 1024
                  ? require(`../../../../../assets/${itm.img1}`).default
                  : require(`../../../../../assets/${itm.img2}`).default
              }
              alt=""
            />
            <div className="text">
              <div dangerouslySetInnerHTML={{ __html: itm.text }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Animation023;
